import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import Logo from './Logo';
import './Navbar.css';

// Importar logo (se existir)
let logoImage;
try {
  logoImage = require('../assets/images/logo.png');
} catch (e) {
  // Logo não encontrado, usar o padrão
  logoImage = null;
}

/**
 * Componente Navbar conforme doc 06-guia-de-estilo-frontend.md
 * Visível apenas após login
 */

const Navbar = () => {
  const { user, logout, canAccessJogadores, canAccessRodadas, canAccessFinanceiro, canAccessRanking, canAccessNocautes } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <Link to="/dashboard" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', gap: '12px' }}>
            <Logo size="small" imageSrc={logoImage || undefined} />
            {user && user.nome && (
              <span className="user-name-brand">{user.nome}</span>
            )}
          </Link>
        </div>
        
        <div className="navbar-menu">
          <Link to="/dashboard" className="navbar-link">Home</Link>
          {canAccessJogadores && (
            <Link to="/jogadores" className="navbar-link">Jogadores</Link>
          )}
          {canAccessRodadas && (
            <Link to="/rodadas" className="navbar-link">Rodadas</Link>
          )}
          {canAccessNocautes && (
            <Link to="/nocautes" className="navbar-link">🥊 Nocautes</Link>
          )}
          {canAccessNocautes && (
            <Link to="/trocas" className="navbar-link">🔄 Trocas</Link>
          )}
          {canAccessRanking && (
            <Link to="/ranking" className="navbar-link">Ranking</Link>
          )}
          <Link to="/financeiro" className="navbar-link">Financeiro</Link>
        </div>

        <div className="navbar-user">
          <Link to="/alterar-senha" className="navbar-link">
            🔐 Alterar Senha
          </Link>
          <button onClick={handleLogout} className="btn btn-logout">
            Sair
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
